import { render, staticRenderFns } from "./tipOne.vue?vue&type=template&id=83bc0f92&scoped=true&"
import script from "./tipOne.vue?vue&type=script&lang=js&"
export * from "./tipOne.vue?vue&type=script&lang=js&"
import style0 from "./tipOne.vue?vue&type=style&index=0&id=83bc0f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bc0f92",
  null
  
)

export default component.exports